import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UniqueEntityID } from '@digibricks/domains';
import { Answer } from '../answer';
import { MatchingCorrectAnswer } from '../correct-answers';
import { QuestionType } from '../question-type';
import { QuestionRelease } from './question-release';
import { MatchingQuestion, SubMatchingQuestion } from '../questions';
import { Score } from '../score';
export var MatchingQuestionRelease = /*#__PURE__*/function (_QuestionRelease) {
  _inherits(MatchingQuestionRelease, _QuestionRelease);

  var _super = _createSuper(MatchingQuestionRelease);

  function MatchingQuestionRelease() {
    _classCallCheck(this, MatchingQuestionRelease);

    return _super.apply(this, arguments);
  }

  _createClass(MatchingQuestionRelease, [{
    key: "answers",
    get: function get() {
      return this.props.answers;
    }
  }, {
    key: "correctAnswers",
    get: function get() {
      return this.props.correctAnswers;
    }
  }, {
    key: "subQuestions",
    get: function get() {
      return this.props.subQuestions;
    }
  }, {
    key: "isCorrect",
    value: function isCorrect(subQuestionId, answerId) {
      if (!answerId) {
        return false;
      }

      var correctAnswer = this.correctAnswers.find(function (c) {
        return c.subQuestionId === subQuestionId;
      });

      if (!correctAnswer) {
        return false;
      }

      return correctAnswer.answerId === answerId;
    }
  }, {
    key: "cloneExtendedProps",
    value: function cloneExtendedProps(question, newQuestionProps, hasCorrectAnswer, showExplanation) {
      var props = _objectSpread(_objectSpread({}, newQuestionProps), {}, {
        answers: this.props.answers,
        correctAnswers: hasCorrectAnswer ? this.props.correctAnswers : [],
        subQuestions: this.props.subQuestions
      }, showExplanation ? {
        explanation: this.props.explanation
      } : '');

      return MatchingQuestionRelease.create(props);
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(MatchingQuestionRelease.prototype), "toJsonObject", this).call(this)), {}, {
        answers: this.props.answers.map(function (answer) {
          return answer.toJsonObject();
        }),
        correctAnswers: this.props.correctAnswers.map(function (correctAnswer) {
          return correctAnswer.toJsonObject();
        }),
        subQuestions: this.props.subQuestions
      });
    }
  }, {
    key: "convertToQuestion",
    value: function convertToQuestion() {
      var baseProps = _get(_getPrototypeOf(MatchingQuestionRelease.prototype), "convertToQuestionProps", this).call(this);

      var questionOrError = MatchingQuestion.create(_objectSpread(_objectSpread({}, baseProps), {}, {
        answers: this.props.answers,
        correctAnswers: this.props.correctAnswers,
        subQuestions: this.props.subQuestions
      }));
      return questionOrError.getValue();
    }
  }, {
    key: "addIndex",
    value: function addIndex(index) {
      this.props.index = index;
      return Result.ok();
    }
  }, {
    key: "addNextIndex",
    value: function addNextIndex(index) {
      this.props.nextIndex = index;
      return Result.ok();
    }
  }, {
    key: "updateSubQuestions",
    value: function updateSubQuestions(subQuestions) {
      this.props.subQuestions = subQuestions;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var resultOrError = this.validate(props);

      if (resultOrError.isFailure) {
        return Result.fail(resultOrError.error);
      }

      var basePropsOrError = _get(_getPrototypeOf(MatchingQuestionRelease), "createBaseProps", this).call(this, props);

      if (basePropsOrError.isFailure) {
        return Result.fail(basePropsOrError.error);
      }

      var defaultProps = _objectSpread(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), props), {}, {
        type: QuestionType.Matching
      });

      return Result.ok(new MatchingQuestionRelease(defaultProps, new UniqueEntityID(props.id)));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var answers = data.answers,
            correctAnswers = data.correctAnswers,
            subQuestions = data.subQuestions;

        var basePropsOrError = _get(_getPrototypeOf(MatchingQuestionRelease), "fromJsonBase", this).call(this, data);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        var answerResultCombine = answers.map(function (a) {
          return Answer.fromJson(a);
        });
        var answerPropsOrError = Result.combineArray(answerResultCombine);

        if (answerPropsOrError.isFailure) {
          return Result.fail(answerPropsOrError.error);
        }

        var correctAnswerProps = correctAnswers ? correctAnswers.map(function (c) {
          var _subQuestions$find;

          return MatchingCorrectAnswer.create({
            id: c.id,
            answerId: c.answerId,
            subQuestionId: c.subQuestionId,
            score: Score.create(c.score).getValue(),
            index: (subQuestions === null || subQuestions === void 0 ? void 0 : (_subQuestions$find = subQuestions.find(function (s) {
              return c.subQuestionId === s.id.toString();
            })) === null || _subQuestions$find === void 0 ? void 0 : _subQuestions$find.index) | 0
          }).getValue();
        }) : [];
        var subQuestionProps = subQuestions ? subQuestions.map(function (s) {
          return SubMatchingQuestion.create({
            id: s.id,
            index: s.index,
            description: s.description
          }).getValue();
        }) : [];
        return this.create(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
          type: QuestionType.Matching,
          answers: answerPropsOrError.getValue(),
          correctAnswers: correctAnswerProps.sort(function (a, b) {
            return a.index - b.index;
          }),
          subQuestions: subQuestionProps
        }));
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return MatchingQuestionRelease;
}(QuestionRelease);